import { environment } from '../../environments/environment';

// Deduplicates concurrent calls for the same banner type so navigation back
// to a page never re-fetches. The module is a singleton, so this survives
// the component lifetime and is shared between main.ts pre-fetch and the
// HeroComponent effect.
const resolved = new Map<string, any>();
const pending  = new Map<string, Promise<any>>();

export const getBannerByType = (type: string): Promise<any> => {
  const key = type.toUpperCase();
  if (resolved.has(key)) return Promise.resolve(resolved.get(key));
  if (pending.has(key))  return pending.get(key)!;

  const req = fetch(`${environment.API_BASE_URL}banner/${key}`)
    .then(r => {
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      return r.json();
    })
    .then(result => {
      if (result.data?.imageUrl) {
        result.data.imageUrl = result.data.imageUrl
          .replace(/,$/, '')
          .replace('dimzvejtth7ffs.cloudfront.net', 'd1mzvejtth7ffs.cloudfront.net')
          .trim();
      }
      const data = result.data ?? null;
      if (data) resolved.set(key, data);
      pending.delete(key);
      return data;
    })
    .catch(err => {
      pending.delete(key);
      console.error(`Error fetching banner for type ${key}:`, err);
      throw err;
    });

  pending.set(key, req);
  return req;
};
